// src\pages\News\NewsPage.tsx

export const NewsPage = () => {
    return (
        <div className="">
            <h2>NewsPage</h2>
        </div>
    )
}

export default NewsPage